import { EmbeddedAgentView } from "../agentic/EmbeddedAgentView";

// Sprint 8 — Vue D2 agent-first pour /companies.
// Suggested prompts orientés gouvernance compte (Théo workflow commercial).

const SUGGESTED_PROMPTS = [
  "Entreprises SSI chaudes sans action prévue cette semaine",
  "Plus gros comptes payants par revenu mensuel",
  "Entreprises orphelines (sans contact actif)",
  "Comptes les plus à risque de churn",
  "Briefs pré-call pour mes RDV de demain",
  "Quelles entreprises n'ont pas eu d'activité depuis 30j ?",
];

export function CompanyAgentView() {
  return (
    <EmbeddedAgentView
      pageId="companies"
      pageLabel="Entreprises"
      suggestedPrompts={SUGGESTED_PROMPTS}
    />
  );
}
